import React, { useEffect } from 'react';

/**
 * Slider component: Renders a slider input.
 *
 * @param {function} onSliderChange - function to handle slider value change
 * @param {string} isPaid - selected option for the slider
 */
const Slider = ({ onSliderChange, isPaid, sliderValue, setFormData, formData, available_quantity }) => {
  
  const getMaxValue = () => {
    const safeAvailable = Math.max(1, available_quantity); // Ensure minimum of 1
    if (isPaid) {
      return safeAvailable >= 10 ? 10 : safeAvailable;
    } else {
      return safeAvailable >= 5 ? 5 : safeAvailable;
    }
  };

  const max = getMaxValue();

  const handleSliderChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setFormData({ ...formData, max_occupancy: value });
    onSliderChange(value);
  };

  useEffect(() => {
    const newValue = Math.max(1, Math.min(sliderValue, max)); // Clamp between 1 and max
    setFormData({ ...formData, max_occupancy: newValue });
    onSliderChange(newValue);
  }, [isPaid, available_quantity]);

  return (
    <div>
      <input
        className="slider"
        type="range"
        min={1}
        max={max}
        value={Math.max(1, Math.min(sliderValue, max))} // Ensure value stays valid
        onChange={handleSliderChange}
      />
    </div>
  );
};

export default Slider;
